import React, { useContext, useState, useEffect} from 'react';
import styled from 'styled-components';
import ui from 'config-app/ui';
import Preview from 'components/Preview/index';
import Steps from 'components/Steps/index';
import Details from 'components/Details/index';
import useUrlPram from 'hooks/useUrlPram';
import useCustomData from 'hooks/useCustomData';
import { appStore } from 'store/app';

const Home = () => {

  const [appState] = useContext(appStore);
  const discountRate = appState.customData.bottle.wc_discount_rate;
  const labels = window.theme;

  // iOS14以下かどうか
  let isOldIos = false;

  // iOS14以下の場合、カスタムCSSの--vhに画面高さの1%を指定
  const setFillHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  // UAを判定
  const ua = parseFloat(('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1]).replace('undefined', '3_2').replace('_', '.').replace('_', ''));

  // iOS14以下の場合を判定
  if (ua < 15) {
    setFillHeight();
    isOldIos = true;
  }

  // 会員価格を表示するかどうか
  let isMember = false;
  if (discountRate > 0) {
    isMember = true;
  }

  // LocatStorageから使用言語を取得
  let wglang = localStorage.getItem('wglang');
  // 設定がない場合日本語に
  if(!wglang){
      wglang = labels.defaultWglang;
  }

  // 戻るリンクの初期化
  var url = labels.urlForProduct.replace(/\{wglang\}/g,wglang);
  useEffect(() => {
    let successHistoryBack = false;
    window.addEventListener('unload',()=>{
      successHistoryBack = true;
    });
    window.addEventListener('beforeunload',()=>{
      successHistoryBack = true;
    });
    // 同ドメインから遷移したかどうか
    var isSameDomain = false;
    var matches = document.referrer.match(/https?:\/\/([^\/]+).*/);
    if(document.referrer && matches && 1 < matches.length){
      const domain = matches[1].replace('store.','').replace('bengal.','').replace('www.','');
      isSameDomain = -1 < window.location.hostname.indexOf(domain);
    }
    // 同ドメインから遷移してきた場合、戻るボタンはhistory.backで遷移
    if(isSameDomain) {
    var aReturn = document.querySelector(".return");
        aReturn.addEventListener("click", function (e) {
            e.preventDefault();
            window.history.back();
            setTimeout(()=>{
              if(!successHistoryBack){
                  window.location.href = document.referrer ? document.referrer : e.target.href;
              }
            },200);
        });
      }
  }, []);

  // ユーザ選択の状態をURLパラメータに設定
  useUrlPram();

  // ユーザ選択の状態から customData を生成してステート更新
  useCustomData();

  //レイアウト調整
  const [classNames, setClassNames] = useState(``);
  let is2lines = false;
  let is3lines = false;

  useEffect(() => {
    var titleHeight = document.querySelector('.productName').clientHeight;
    if (titleHeight > 25 && titleHeight < 50) {
      is3lines = false;
      is2lines = true;
    } else if (titleHeight > 65) {
      is2lines = false;
      is3lines = true;
    }
    setClassNames(`${is2lines ? is3lines ? "" : "modify2lines" :  "modify3lines"}`);
    return() => {
      document.querySelector('.cbContainer').classList.add('load');
    }
  }, [appState]);

  return (
    <Container className="cbContainer">
      <Content className={isOldIos && "modified"}>
        <ColA className={`${isMember ? "member" : ""} ${classNames}`}>
          <Preview />
        </ColA>
        <ColB>
          <Details />
          <Steps />
          <BackLink>
            <a href={url} className="return">
            <svg class="previous-link__icon" xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16">
  <path id="_" data-name=">" d="M8,0,1.7,8,8,16,6.3,16,0,8,6.3,0Z" transform="translate(0 0)" fill="#333"></path>
</svg>
            {labels.back}
            </a>
          </BackLink>
        </ColB>
      </Content>
    </Container>
  );
};

export default Home;

const Container = styled.div`
 ${ui.MQ_XS_SM} {
    position: relative; 
    height: 100%;
    padding-bottom: 148px;
    &::after {
      position: fixed;
      display: block;
      content: '';
      width: 100%;
      height: 100%;
      background: #fff;
      z-index: 2;
      top: 0;
      left: 0;
    }
    &.load {
      &::after {
        display: none;
      }
    }
  }
`;

const Content = styled.div`

  ${ui.MQ_MD_LG} {
    width: ${ui.CONTENT_MAX_WIDTH};
    display: flex;
    margin: 0 auto;
    padding: 180px 0 200px;
  }

  ${ui.MQ_XS_SM} {
    position: relative; 
    height: calc(100vh - 50px);
    &.modified {
      height: calc((var(--vh, 1vh) * 100) - 50px);
    }
  }
`;

const ColA = styled.div`
  ${ui.MQ_XS_SM} {
    width: 220px;
    height: 220px;
    position: absolute;
    top: 126px;
    left: 50%;
    transform: translateX(-50%);
    @media screen and (max-device-height: 700px) {
      height: 170px;
      width: 170px;
    }
    &.member {
      top: 138px;
      &.modify2lines {
        top: 165px;
      }
      &.modify3lines {
        top: 192px;
      }
    }
    &.modify2lines {
      top: 141px;
    }
    &.modify3lines {
      top: 168px;
    }
  }

  ${ui.MQ_MD_LG} {
    flex-basis: 55%;
    flex-shrink: 0;
    max-width: 520px;
    min-width: 0;
    margin-right: 59px;
  }
`;

const ColB = styled.div`
  ${ui.MQ_MD_LG} {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
    min-width: 0;
  }
  ${ui.MQ_XS_SM} {
    position: relative;
    height: 100%;
    margin-top: 50px;
  }
`

const BackLink = styled.div` {
  display: block;
  .previous-link__icon {
    vertical-align: -10%;
    display: inline-block;
    margin-right: 10px;
  }
  a {
    text-decoration: none;
  }
  ${ui.MQ_MD_LG} {
    margin-top: 50px;
    cursor: pointer;
  }
  ${ui.MQ_XS_SM} {
    .previous-link__icon {
      height: 13px;
    }
    background: #fff;
    position: absolute;
    bottom: 0;
    transform: translateY(100%);
    height: 148px;
    width: 100%;
    text-align: center;
    a {
      display: block;
      margin-top: 30px;
    }
  }
}
`
;
